import io from 'socket.io-client';
let socket;
export const initiateSocket = () => {
    socket = io('http://localhost:3000', { transports: ['websocket'] });
    console.log(`Connecting socket...`);
    if (socket) {
        socket.emit('notification_to_');
        console.log(`Socket connected...`);
    }
}
export const disconnectSocket = () => {
    console.log('Disconnecting socket...');
    if (socket) {
        socket.disconnect();
        console.log('Socket Disconnected...');
    }
}
export const subscribeToChat = (user, cb) => {

    if (!socket) return (true);
    socket.on('notification_to_' + user.username, msg => {
        // console.log('Websocket event received!');
        return cb(null, msg);
    });
}
// export const sendMessage = (room, message) => {
//     if (socket) socket.emit('chat', { message, room });
// }